/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_CloseInputs */

const en_cover_letters_close = /** @type {(inputs: Cover_Letters_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const de_cover_letters_close = /** @type {(inputs: Cover_Letters_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const fr_cover_letters_close = /** @type {(inputs: Cover_Letters_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const es_cover_letters_close = /** @type {(inputs: Cover_Letters_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const it_cover_letters_close = /** @type {(inputs: Cover_Letters_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi`)
};

const nl_cover_letters_close = /** @type {(inputs: Cover_Letters_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sluiten`)
};

const pl_cover_letters_close = /** @type {(inputs: Cover_Letters_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknij`)
};

const fi_cover_letters_close = /** @type {(inputs: Cover_Letters_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sulje`)
};

const da_cover_letters_close = /** @type {(inputs: Cover_Letters_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luk`)
};

const sv_cover_letters_close = /** @type {(inputs: Cover_Letters_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stäng`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Cover_Letters_CloseInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_close = /** @type {((inputs?: Cover_Letters_CloseInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_CloseInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_close(inputs)
	if (locale === "fr") return fr_cover_letters_close(inputs)
	if (locale === "es") return es_cover_letters_close(inputs)
	if (locale === "it") return it_cover_letters_close(inputs)
	if (locale === "nl") return nl_cover_letters_close(inputs)
	if (locale === "pl") return pl_cover_letters_close(inputs)
	if (locale === "fi") return fi_cover_letters_close(inputs)
	if (locale === "da") return da_cover_letters_close(inputs)
	if (locale === "sv") return sv_cover_letters_close(inputs)
	return en_cover_letters_close(inputs)
});